const isEllipsisActive = (el: HTMLElement) => el.offsetWidth < el.scrollWidth;

export default isEllipsisActive;
